exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg{background-color:#d3d3d3}[data-tag=P]{color:green}[data-tag=A]{color:red}[data-tag=L]{color:blue}[data-tag=H]{color:#00008b}.header{display:flex;align-items:center;margin-bottom:10px}.header img{width:100px;margin-right:20px}.header-text{flex:1;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-390f6853","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/ClientSummaryPrint.vue
// module id = 186
// module chunks = 0